import { BookingOrGuest } from '../../../BookingCard';
import utcStringToEpoch from '../../../utilities/utcStringToEpoch';
import { BookingsSplitByStatus } from '../../../../pages/me/[userID]/index';

// Reduce function to split the result of the GET bookings API call into previous, current and upcoming
export function bookingsSplit(
  bookings: BookingOrGuest[],
): BookingsSplitByStatus {
  const today = Math.floor(new Date().getTime());

  const bookingsSorted = bookings.sort(
    (a, b) =>
      utcStringToEpoch(a.group.start.utc) - utcStringToEpoch(b.group.start.utc),
  );

  const result: BookingsSplitByStatus = {
    previousBookings: [],
    currentBookings: [],
    upcomingBookings: [],
    cancelledBookings: [],
  };

  bookingsSorted.forEach(
    // eslint-disable-next-line array-callback-return
    (booking) => {
      const startDate = utcStringToEpoch(booking.group.start.utc);
      const endDate = utcStringToEpoch(booking.group.end.utc);

      if (booking.spaces && !booking.spaces.some((i) => i.active === true)) {
        result.cancelledBookings.push(booking);
      } else if (endDate < today) {
        result.previousBookings.push(booking);
      } else if (startDate <= today && endDate >= today) {
        result.currentBookings.push(booking);
      } else {
        result.upcomingBookings.push(booking);
      }
    },
  );

  return result;
}
